// src/components/BlacklistHistory.js

import React from 'react';
import './BlacklistHistory.css'; // فایل استایل که در مرحله بعد می‌سازیم

const BlacklistHistory = ({ history }) => {
    // اگر سابقه‌ای وجود نداشت، یک پیام نمایش بده
    if (!history || history.length === 0) {
        return (
            <div className="blacklist-callout-info">
                <p>هیچ سابقه‌ای در لیست سیاه برای این کاربر ثبت نشده است.</p>
            </div>
        );
    }

    return (
        <div className="blacklist-list-preview">
            <h3>سوابق لیست سیاه و تذکر</h3>
            <table className="blacklist-table">
                <thead>
                <tr>
                    <th>دلیل</th>
                    <th>تاریخ ثبت</th>
                    <th>نوع</th>
                </tr>
                </thead>
                <tbody>
                {history.map((record, index) => (
                    <tr key={record.id || index}>
                        <td>{record.reason}</td>
                        <td className="shamsi-date">{record.created_at_shamsi}</td>
                        <td>
                <span className={record.is_black_list === 1 ? 'status-active' : 'status-inactive'}>
                  {record.is_black_list === 1 ? 'لیست سیاه' : 'لیست تذکر'}
                </span>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default BlacklistHistory;
